export function canManageAdmins(admin) {
  return admin?.adminRole === 'admin' && admin.isActive !== false;
}

export function canChangeAdminPassword(actor, target) {
  if (!canManageAdmins(actor) || !actor._id || !target?._id) return false;
  return String(actor._id) === String(target._id)
    || (actor.isJustin === true && target.adminRole === 'admin')
    || ['hotel', 'events', 'grat', 'casino'].includes(target.adminRole);
}
